import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import './index.css';
import { Provider } from 'react-redux';
import { store } from './app/store';
import { StyledEngineProvider } from '@mui/joy/styles';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
	<StyledEngineProvider injectFirst>
		<Provider store={store}>
			<Router>
				<App />
			</Router>
		</Provider>
	</StyledEngineProvider>,
);
